import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, notification} from 'antd';
import {getPurchaseOrder, removeProductFromPurchaseOrder} from './actions';
import {Link} from "react-router-dom";
import {getDescriptionFromError} from "../utils/errors";
import ResponsiveTable from "../common/ResponsiveTable";
import {decodeParams} from "../utils/params";

const purchaseOrderColumns = [
  {
    title: 'Product',
    dataIndex: 'productDisplay',
    key: 'productDisplay'
  },
  {
    title: 'Order Code',
    dataIndex: 'supplierOrderCode',
    key: 'orderCode'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, {page, purchaseId, status, productId}) => {
      const encodedPurchaseId = encodeURIComponent(purchaseId);
      const encodedProductId = encodeURIComponent(productId);
      switch (status) {
        case 'Draft':
        case 'Sent':
          return (
            <React.Fragment>
              <Link to={`/purchase-order/update-product/${encodedPurchaseId}/${encodedProductId}`}>Edit</Link>
              {' | '}
              <Link to="#" onClick={e => page.handleRemove(e, productId)}>Remove</Link>
            </React.Fragment>
          );
        case 'Received':
          return (<Link to={`/product/receive/${encodedProductId}/${encodedPurchaseId}`}>Receive</Link>);
        default:
          return null;
      }
    }
  }
];

class PurchaseOrderPage extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.purchaseId !== decodeParams(this.props.match.params).purchaseId) {
      this._load();
    }
  }

  _load = () => {
    const {purchaseId} = decodeParams(this.props.match.params);
    if (purchaseId) {
      this.props.getPurchaseOrder({purchaseId});
    }
  };

  handleAdd = e => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.history.push('/purchase-order/add-product/' + purchaseId);
  };

  handleRemove = async(e, productId) => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    try {
      await this.props.removeProductFromPurchaseOrder({purchaseId, productId});
      this._load();
    } catch (err) {
      notification.error({
        message: 'Failed',
        description: getDescriptionFromError(err)
      });
    }
  };

  render() {
    const {loading, purchaseOrder, history} = this.props;
    const {purchaseId} = decodeParams(this.props.match.params);
    const items = (purchaseOrder.items || []).map(item => ({...item, purchaseId, status: purchaseOrder.status, page: this}));
    let extra = null;
    if (purchaseOrder && ['Draft', 'Sent'].indexOf(purchaseOrder.status) >= 0) {
      extra = <Button type="primary" icon="plus" onClick={this.handleAdd}>Add</Button>;
    }
    return <React.Fragment>
      <Card title={[
        <Button key='arrow-left' icon="arrow-left" onClick={history.goBack} />,
        " Purchase Order Items"]} extra={extra}>
        <ResponsiveTable
          loading={loading}
          columns={purchaseOrderColumns}
          dataSource={items}
          rowKey="productId"
        />
      </Card>
    </React.Fragment>;
  }
}

PurchaseOrderPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  removeProductFromPurchaseOrder: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
  loading: state.purchaseOrder.purchaseOrderLoading || state.purchaseOrder.removeProductFromPurchaseOrderLoading,
});

const mapDispatchToProps = dispatch => ({
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
  removeProductFromPurchaseOrder: payload => (dispatch(removeProductFromPurchaseOrder(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/PurchaseOrderPage.js